import { render, staticRenderFns } from "./viewBOSTF.vue?vue&type=template&id=4e8b3980&scoped=true"
import script from "./viewBOSTF.vue?vue&type=script&lang=js"
export * from "./viewBOSTF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b3980",
  null
  
)

export default component.exports